import {
  Button,
  Checkbox,
  DatePicker,
  Drawer,
  Input,
  message,
  Select,
  Space,
  Tag,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { editPurchaseOrder } from "../../../../apis/po.api";
import { usePermissions } from "../../../../custom_hooks/permission/permission_hook";
import { ApprovalReasons } from "../../../../pages/refunds-v2";
import { range } from "../../../client/add_client_booking_form";

export interface BankDetails {
  bank_account_number: string;
  bank_ifsc: string;
  branch_upi: string;
}
export interface POOrderDetailsProps {
  created_by: string;
  created_at?: any;
  estimate_created_at?: any;
  live_location_link: string;
  client: string;
  lead_id: string;
  quotation_no: string;
  status: string;
  bank_details?: BankDetails;
  dispatch_time: string;
  delivery_datetime?: string | null;
  handleDeliveryTimeChange?: (dateString: string) => void;
  estimate_additional_charges?: Array<any>;
  type_of_order?: string;
  po_status?: string;
  po_id?: string;
  refresh?: () => void;
  alternate_contact_detail:any
}

// export const dispatchDateAllowChangeIDs = [
//   "33898f77-665e-4f92-8807-3a9efb7f9dd8", // Ajinkya
//   "50a0ff56-2500-4783-939b-27402e251c80", // Sanjay
//   "9d2086b5-7ae7-4a46-9fe2-6cfd47dc585a", // Aruna
//   "404f8ca6-0cca-4acc-9883-fd0498804dc0", // Sarthak
//   "bd29266c-c428-4f89-8eee-8a08e2bcfa8b", // Manish
//   // "1e0411d9-a5b1-45bd-bd2d-02c5bbcc0962", // Gourab
//   "020ba74c-6e2f-4cf6-bd24-e9363f6f8bca", // Yogi
//   "3a8ae7b4-40cf-442b-9f88-7f1a3d3ad01b", // Kokila
//   "ee64d1ed-4baf-4e66-850e-40f70feb0063", // Prakhar
//   // "b6245e5f-0b09-47d7-9c29-5c7cb9e1edeb", // Pavan
//   // "7293719c-e006-464c-8803-67693d46070a", // Khoushika
//   "d2c3e746-240f-45bd-9aea-c64222915f85", // Monica
//   // "450fe446-1402-44ce-bc1e-96995181f53e", // Sanchith
//   // "80535fb9-8ba1-413b-843f-aee21d079248", // Ganesh
//   "1f5b8e08-462a-4d84-9041-c4b47d5f3731", // Priyadarshini
//   // "9a626a13-080b-430e-88a1-e180a2431fad", // Chaitra
//   "31fd5d70-9dd0-4b19-a49a-dafd7da488d4", // Kousika
//   "e07a6c6d-2df9-427b-956b-2e45982ae33d", // Parikshit
//   "3f565608-0a67-4ed2-8f42-ce5dc69cfc07", //Harsha
//   "d76b722f-9b13-48e6-b2a4-352246dde09f", //Aditya
// ];

export const chargeButtonsAllowChangeIDs = [
  "1f5b8e08-462a-4d84-9041-c4b47d5f3731", // Priyadarshini
  "d2c3e746-240f-45bd-9aea-c64222915f85", // Monica
  "1258356f-5d18-401f-a883-2bf142e1f46c", //Adul
  "404f8ca6-0cca-4acc-9883-fd0498804dc0", // Sarthak
  "bd29266c-c428-4f89-8eee-8a08e2bcfa8b", // Manish
  "020ba74c-6e2f-4cf6-bd24-e9363f6f8bca", // Yogi
  "ee64d1ed-4baf-4e66-850e-40f70feb0063", // Prakhar
  "7293719c-e006-464c-8803-67693d46070a", // Khoushika
  "d76b722f-9b13-48e6-b2a4-352246dde09f", //Aditya
];

const POOrderDetails = ({
  created_by,
  created_at,
  estimate_created_at,
  live_location_link,
  client,
  lead_id,
  quotation_no,
  status,
  bank_details,
  dispatch_time,
  delivery_datetime,
  handleDeliveryTimeChange,
  estimate_additional_charges,
  type_of_order,
  po_status,
  po_id,
  refresh,
  alternate_contact_detail
}: POOrderDetailsProps) => {
  const { hasPermission } = usePermissions();
  const userRole = localStorage.getItem("user_role");
  const [approvalType, setApprovalType] = useState<string | null>(null);
  const [raiseToWarehouse, setRaiseToWarehouse] = useState<boolean>(false);

  const [raiseDelivery, setRaiseDelivery] = useState(false);
  const [reverseDispatchTime, setReverseDispatchTime] = useState<string | null>(
    null
  );

  const [approvalReason, setApprovalReason] = useState<string | null>(null);
  const [approvalRemark, setApprovalRemark] = useState<string>();
  const [showApprovalRemark, setShowApprovalRemark] = useState(false);

  useEffect(() => {
    if (approvalReason === "Others") {
      setShowApprovalRemark(true);
    } else {
      setShowApprovalRemark(false);
    }
  }, [approvalReason]);


  const unloading = useMemo(() => {
    if (!estimate_additional_charges) return null;

    const unloading = estimate_additional_charges.find((charge) =>
      charge?.charge_type?.toLowerCase().includes("unloading")
    );
    if (!unloading) return null;

    const amount = parseFloat(unloading?.amount);

    if (amount === 0) {
      return null;
    }

    return (
      <Space className="py-2">
        <Tag color="green">Unloading Paid For: {unloading?.amount}</Tag>
      </Space>
    );
  }, [estimate_additional_charges]);

  const handleApproval = async (type: string) => {
    let delivery_status = null;
    switch (type) {
      case "return":
        delivery_status = "return_approved";
        break;
      case "exchange":
        delivery_status = "exchange_approved";
        break;
      default:
        delivery_status = null;
        break;
    }

    if (!delivery_status) {
      message.error("Could not approve the request");
      return;
    }

    const payload = {
      po_delivery_status: delivery_status,
      remark: showApprovalRemark ? approvalRemark : approvalReason,
    } as Record<string, any>;
    if (raiseDelivery) {
      payload.dispatch_time = reverseDispatchTime;
    }
    if (raiseToWarehouse) {
      payload.warehouse_delivery = "True";
    }

    const response = await editPurchaseOrder(po_id, payload);
    if (response) {
      message.success("Request approved successfully");
    } else {
      message.error("Could not approve the request");
    }
    setApprovalType(null);
    setRaiseToWarehouse(false);

    if (refresh) {
      refresh();
    }
  };

  const approval = () => {
    if (type_of_order === "po") return null;

    if (!hasPermission("refund.approve")) return null;

    if (po_status === "return_requested") {
      return (
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Approve return?</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>
                <Button
                  type="primary"
                  className="th-font-size-14 th-font-weight-500"
                  onClick={() => {
                    if (!dispatch_time) {
                      setApprovalType("return");
                    } else {
                      setApprovalType("return");
                    }
                  }}
                  size="small"
                >
                  Approve return
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (po_status === "return_approved") {
      return (
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Return Approval</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>
                <Tag color="green">Approved</Tag>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (po_status === "exchange_requested") {
      return (
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Approve exchange?</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>
                <Button
                  type="primary"
                  className="th-font-size-14 th-font-weight-500"
                  onClick={() => {
                    if (!dispatch_time) {
                      setApprovalType("exchange");
                    } else {
                      setApprovalType("exchange");
                    }
                  }}
                  size="small"
                >
                  Approve exchange
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (po_status === "exchange_approved") {
      return (
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Exchange Approval</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>
                <Tag color="green">Approved</Tag>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (po_status === "refund_requested") {
      return (
        // <div className="row py-2">
        //   <div className="col-4 th-font-weight-500">Approve refund?</div>
        //   <div className="col-8">
        //     <div className="d-flex">
        //       <div className="pe-1">:</div>
        //       <div>
        //         <Button
        //           type="primary"
        //           className="th-font-size-14 th-font-weight-500"
        //           onClick={() => {
        //             if (!dispatch_time) {
        //               handleApproval("refund");
        //             } else {
        //               setApprovalType("refund");
        //             }
        //           }}
        //           size="small"
        //         >
        //           Approve refund
        //         </Button>
        //       </div>
        //     </div>
        //   </div>
        // </div>
        null
      );
    }
    if (po_status === "refund_approved") {
      return (
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Refund Approval</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>
                <Tag color="green">Approved</Tag>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="p-3 py-2 row mb-2">
      <div className="th-font-size-16 th-font-weight-600 pb-3 primary-color-text">
        Order Details
      </div>
      <div className="col">
        <div className="row">
          <div className="col-4 th-font-weight-500">Created By</div>
          <div className="col-8 pb-1">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{created_by ?? "System"}</div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">PO Created At</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{dayjs(created_at).format("DD MMM YYYY, HH:mm")}</div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">PI Created At</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>
                {dayjs(estimate_created_at).format("DD MMM YYYY, HH:mm")}
              </div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Type of Order</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{type_of_order}</div>
            </div>
          </div>
        </div>
        {approval()}
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Client </div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{client}</div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Alternate Client Name </div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{alternate_contact_detail?.contact_person_name}</div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Alternate Client Contact </div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{alternate_contact_detail?.contact_person_contact}</div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Lead ID</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{lead_id}</div>
            </div>
          </div>
        </div>
        {/* <div className="row py-2">
          <div className="col-4 th-font-weight-500">Quotation No.</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{quotation_no}</div>
            </div>
          </div>
        </div> */}
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Status</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{status}</div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Bank Details</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div className="">
                <div>Account Number ({bank_details?.bank_account_number})</div>
                <div>IFSC Code ({bank_details?.bank_ifsc})</div>
                <div>UPI ({bank_details?.branch_upi})</div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row py-2">
          <div className="col-4 th-font-weight-500">Location Link</div>
          <div className="col-8">
            <div className="d-flex">
              <div>{live_location_link}</div>
            </div>
          </div>
        </div> */}
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Dispatch Date & Time</div>
          <div className="col-8">
            <div>{dispatch_time ? dayjs(dispatch_time).format("DD MMM YYYY, HH:mm") : "Not set"}</div>

            {/* {hasPermission("po.update_dispatch_time") ? (
              <DatePicker
                showSecond={false}
                showTime={{
                  minuteStep: 30,
                  format: "HH:mm",
                  hideDisabledOptions: true,
                }}
                disabledTime={(current: any) => {
                  return {
                    disabledHours: () => range(0, 10).concat(range(18, 24)),
                  };
                }}
                className="w-100"
                placeholder="Select Dispatch Time"
                value={dayjs(dispatch_time ?? null)}
                onChange={(e: any, dateString) => {
                  // setData("dispatch_time", dateString);
                  handleChangeDispatchDateTime(dateString);
                }}
              />
            ) : (
              <div>{dayjs(dispatch_time).format("DD MMM YYYY, HH:mm")}</div>
            )} */}
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Delivery Date</div>
          <div className="col-8">
            {status === "payment_pending" ? (
              <div className="th-font-weight-500" style={{ color: "#b37400" }}>
                Holding stock. Delivery date can't be set
              </div>
            ) : hasPermission("deliverydispatchdatetime.edit") ? (
              <DatePicker
                showSecond={false}
                disabledDate={(current) => {
                  if (hasPermission("admin")) return false;

                  const originalDeliveryDate = delivery_datetime ? dayjs(delivery_datetime) : null;
                  const dispatchDate = dispatch_time ? dayjs(dispatch_time) : null;
                  const isDelivered = po_status === "delivered";

                  // post_sales can select dates earlier than original delivery date but not earlier than dispatch date
                  if (userRole === "post_sales") {
                    // If there's no dispatch date, cannot select any date
                    if (!dispatchDate) {
                      return true;
                    }
                    // If there's a dispatch date, cannot select dates before it
                    if (current < dispatchDate.startOf('day')) {
                      return true;
                    }
                    return false;
                  }

                  // Other roles (non-admin, non-post_sales) cannot select dates before original delivery date unless delivered
                  return !!(originalDeliveryDate && current < originalDeliveryDate.startOf('day') && !isDelivered);
                }}
                disabledTime={(current: any) => {
                  return {
                    disabledHours: () => range(0, 10).concat(range(21, 24)),
                  };
                }}
                className="w-100"
                placeholder="Select Delivery Time"
                value={(() => {
                  console.log("Delivery datetime in DatePicker:", delivery_datetime);
                  if (delivery_datetime) {
                    const parsed = dayjs(delivery_datetime);
                    console.log("Parsed delivery datetime:", parsed.format(), "isValid:", parsed.isValid());
                    return parsed.isValid() ? parsed : null;
                  }
                  return null;
                })()}
                onChange={(e: any, dateString) => {
                  if (handleDeliveryTimeChange) {
                    handleDeliveryTimeChange(dateString);
                  }
                }}
              />
            ) : (
              <div>{delivery_datetime ? dayjs(delivery_datetime).isValid() ? dayjs(delivery_datetime).format("DD MMM YYYY, HH:mm") : "Not set" : "Not set"}</div>
            )}
          </div>
        </div>
        {unloading}
      </div>
      <Drawer
        title="Approve Delivery"
        placement="right"
        onClose={() => setApprovalType(null)}
        open={approvalType !== null}
        width={400}
        extra={
          <Space>
            <Button
              onClick={() => setApprovalType(null)}
              className="th-font-size-14 th-font-weight-500"
            >
              Cancel
            </Button>
          </Space>
        }
      >
        <div className="my-3">
          <Typography.Title level={5} className="th-font-weight-500">
            Reason
          </Typography.Title>
          <Select
            className="w-100"
            placeholder="Select reason"
            onChange={(value) => {
              setApprovalReason(value);
            }}
            value={approvalReason}
          >
            {ApprovalReasons.map((reason) => {
              return (
                <Select.Option key={reason} value={reason}>
                  {reason}
                </Select.Option>
              );
            })}
          </Select>
          {showApprovalRemark && (
            <div className="mt-2">
              <Input.TextArea
                placeholder="Enter remark"
                onChange={(e) => {
                  setApprovalRemark(e.target.value);
                }}
                value={approvalRemark}
                rows={4}
              />
            </div>
          )}
        </div>
        <div className="">
          <div className="mb-4">
            <Checkbox
              checked={raiseDelivery}
              onChange={(e) => {
                setRaiseDelivery(e.target.checked);
              }}
            >
              Raise Delivery
            </Checkbox>
            {raiseDelivery && (
              <DatePicker
                style={{ marginLeft: "1rem" }}
                onChange={(date, dateString) => {
                  setReverseDispatchTime(dateString);
                }}
                placeholder="Select Date"
                format="YYYY-MM-DD"
                disabledDate={(current) => {
                  return current && current < dayjs(new Date());
                }}
              />
            )}
          </div>
          {raiseDelivery && (
            <div className="mb-4">
              <Checkbox
                className="th-font-size-14 th-font-weight-500"
                checked={raiseToWarehouse}
                onChange={(e) => setRaiseToWarehouse(e.target.checked)}
              >
                Deliver to Warehouse
              </Checkbox>
            </div>
          )}
        </div>
        <Button
          type="primary"
          className="th-font-size-14 th-font-weight-500"
          onClick={() => {
            if (!approvalType) return;
            handleApproval(approvalType);
          }}
        >
          Confirm
        </Button>
      </Drawer>
    </div>
  );
};

export default POOrderDetails;
